export type Platform = "ios" | "android" | "web";

export const isIOSOrIPadOS = (): boolean => {
  if (typeof navigator === "undefined") return false;

  return (
    /iPad|iPhone|iPod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};

export const detectPlatform = (): Platform => {
  if (typeof navigator === "undefined") return "web";
  if (isIOSOrIPadOS()) return "ios";

  const userAgent = navigator.userAgent || navigator.vendor;
  return /android/i.test(userAgent) ? "android" : "web";
};
